import { WaitlistFilterPanelFormBean } from './filters/WaitlistFilterPanel.types';

export const WAITLIST_FILTER_PANEL_DEFAULT_VALUES: WaitlistFilterPanelFormBean = {
   healthcareProviderLocations: [],
   practitioners: [],
   reservationPreference: null,
   statuses: [],
   urgent: false,
   encounterModes: [],
   services: [],
   patientAvailabilityDayOfWeek: null,
   patientAvailabilityTimesOfDay: [],
};
